export default "__VITE_ASSET__a0620eeb__"